import { SESSION_STORAGE_VARIABLES, sessionStorageManager } from '@app/services/storageManager';
import { AlertType } from '@app/redux/alerts';

export const checkAlertDismissed = (alertType: AlertType): boolean => {
  const dismissedAlerts = sessionStorageManager.getItem(SESSION_STORAGE_VARIABLES.DISMISSED_ALERTS);

  if (!dismissedAlerts || !Array.isArray(Object.keys(dismissedAlerts))) {
    return false;
  }

  return Object.keys(dismissedAlerts).includes(alertType);
};
